import { IPaginationResourceShort } from '../../../props/general';
import { IVesselRequisitionResourceShortProps, IVesselRequisitionResourceProps, IExtractedVesselRequisitionFormProps } from '../../../props/vessels/requisitions/requisition';
import Request from '../../request';

const VesselRequisitionService = {
  extract: async (data: FormData): Promise<IExtractedVesselRequisitionFormProps> => {
    try {
      const response = await Request.post(`/api/vessels/requisitions/extract`, data, 'multipart/form-data');
      let result: IExtractedVesselRequisitionFormProps = response;

      return result;
    } catch (e) {
      throw (e);
    }
  },
  retrieve: async (qs?: string): Promise<{ data: IVesselRequisitionResourceShortProps[], pagination: IPaginationResourceShort }> => {
    try {
      const results = await Request.get(`/api/vessels/requisitions?${qs || ''}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  read: async (id: string): Promise<IVesselRequisitionResourceProps> => {
    try {
      const results = await Request.get(`/api/vessels/requisitions/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  create: async (data: FormData): Promise<IVesselRequisitionResourceProps> => {
    try {
      const result = await Request.post(`/api/vessels/requisitions`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  update: async (id: string, data: FormData): Promise<IVesselRequisitionResourceProps> => {
    try {
      const result = await Request.post(`/api/vessels/requisitions/${id}?_method=PUT`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  }
};

export default VesselRequisitionService;
